import { Injectable } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { WindowService } from './window.service';
export var NgwWowService = (function () {
    function NgwWowService(windowService) {
        // Observable  source
        this.itemRevealedSource = new Subject();
        // Observable  stream
        this.itemRevealed$ = this.itemRevealedSource.asObservable();
        this.window = windowService.nativeWindow;
    }
    NgwWowService.prototype.init = function (config) {
        var _this = this;
        if (this.window) {
            var conf = config || {};
            // Set callback hook:
            conf.callback = function () { return _this.itemRevealedSource.next(); };
            // Initializes the library
            new WOW(config).init();
        }
    };
    NgwWowService.decorators = [
        { type: Injectable },
    ];
    /** @nocollapse */
    NgwWowService.ctorParameters = [
        { type: WindowService, },
    ];
    return NgwWowService;
}());
//# sourceMappingURL=wow.service.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ngx-wow/services/wow.service.js
// module id = ./node_modules/ngx-wow/services/wow.service.js
// module chunks = vendor